import React from "react";
import Section from "../ui/Section/Section";
import { Grid } from "../ui/Grid/Grid";
import ChartCard from "../ui/Card/ChartCard";
import { CenterRow } from "../ui/Card/Card";
import VBars from "../charts/VBars";
import Donut from "../charts/Donut";
import Legend from "../ui/Legend/Legend";
import MiniMetric from "../ui/MiniMetric/MiniMetric";
import SectionSkeleton from "../ui/SectionSkeleton/SectionSkeleton";
import { SECTIONS } from "../../constants";
import { fmt1, fmtN } from "../../functions/format";
import { CHART_COLORS } from "../../styles/theme";

const { id, title } = SECTIONS.mouvements;

const SKELETON_ROWS = [{ cols: 3, cards: [5, 5, 4] }];

const MouvementsSection = ({ data, isLoading }) => {
    if (isLoading && !data) {
        return (
            <Section id={id} title={title}>
                <SectionSkeleton rows={SKELETON_ROWS} />
            </Section>
        );
    }

    if (!data) return null;

    const turnoverTotal = data.turnoverVolontaire + data.turnoverInvolontaire;
    // anneau neutre quand aucune décomposition n'est disponible
    const turnoverSegments =
        turnoverTotal > 0
            ? [
                  {
                      value: data.turnoverVolontaire,
                      color: CHART_COLORS.violet,
                      tip: `Volontaire : ${fmt1(data.turnoverVolontaire)} %`,
                  },
                  {
                      value: data.turnoverInvolontaire,
                      color: CHART_COLORS.violetSoft,
                      tip: `Involontaire : ${fmt1(
                          data.turnoverInvolontaire
                      )} %`,
                  },
              ]
            : [{ value: 1, color: CHART_COLORS.line }];

    return (
        <Section id={id} title={title}>
            <Grid cols={3}>
                <ChartCard title="Entrées / Sorties">
                    <VBars
                        labels={data.labels}
                        series1={data.seriesEntrees}
                        series2={data.seriesSorties}
                        names={["Entrées", "Sorties"]}
                    />
                    <MiniMetric
                        mt="8px"
                        color={CHART_COLORS.violet}
                        label="Taux d’entrées"
                        value={`${fmt1(data.tauxEntrees)}% (${fmtN(
                            data.entrees
                        )})`}
                    />
                    <MiniMetric
                        color={CHART_COLORS.violetSoft}
                        label="Taux de sorties"
                        value={`${fmt1(data.tauxSorties)}% (${fmtN(
                            data.sorties
                        )})`}
                    />
                </ChartCard>

                <ChartCard title="Décomposition du turnover" fill>
                    <CenterRow>
                        <Donut
                            segments={turnoverSegments}
                            center={`${fmt1(data.turnoverGlobal)}%`}
                            sub="GLOBAL"
                        />
                    </CenterRow>
                    <Legend
                        style={{ marginTop: 9 }}
                        items={[
                            {
                                name: `Volontaire ${fmt1(
                                    data.turnoverVolontaire
                                )}%`,
                                color: CHART_COLORS.violet,
                            },
                            {
                                name: `Involontaire ${fmt1(
                                    data.turnoverInvolontaire
                                )}%`,
                                color: CHART_COLORS.violetSoft,
                            },
                        ]}
                    />
                </ChartCard>

                <ChartCard title="Onboarding / Offboarding" fill>
                    <MiniMetric
                        label="Onboardings en cours"
                        value={fmtN(data.onboardingsEnCours)}
                    />
                    <MiniMetric
                        label="Délai moyen d’onboarding"
                        value={`${fmt1(data.delaiOnboarding)} jours`}
                    />
                    <MiniMetric
                        label="Offboardings en cours"
                        value={fmtN(data.offboardingsEnCours)}
                    />
                    <MiniMetric
                        label="Délai moyen d’offboarding"
                        value={`${fmt1(data.delaiOffboarding)} jours`}
                    />
                </ChartCard>
            </Grid>
        </Section>
    );
};

export default MouvementsSection;
